import { liftPlanUEService } from '@/services/lift-plan-ue/lift-plan-ue-service';
import { projectKeys } from '@/utils/queryKeys';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export const useLiftPlanUECreateMutation = (
  projectId: MaybeRefOrGetter<string>,
) => {
  const queryClient = useQueryClient();
  const pid = computed(() => toValue(projectId));
  return useMutation({
    mutationKey: ['liftPlanUEService', 'post', pid],
    mutationFn: () => liftPlanUEService.create(pid.value),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: projectKeys.liftPlanUE({ projectId: toValue(projectId) }),
      }),
  });
};
